export let clone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export let toFormData = (obj) => {
  let formData = new FormData()

  for (let key in obj) {
    formData.append(key, obj[key])
  }

  return formData
}



// WEBPACK FOOTER //
// ./src/utils/object.js